export const PUBLISH_TRACK_MAX_RETRIES = 3;

export const SYSTEM_PERMISSION_DENIED_ERROR =
  'AgoraRTCError PERMISSION_DENIED: NotAllowedError: Permission denied by system';
export const USER_PERMISSION_DENIED_ERROR =
  'AgoraRTCError PERMISSION_DENIED: NotAllowedError: Permission denied by user';
